var EXTERNAL_INFO_TYPE = {
  HOVER: 'HOVER',
  EXTERNAL: 'EXTERNAL',
  SLIDESHOW: 'SLIDESHOW'
};
export default EXTERNAL_INFO_TYPE;